module.exports = __webpack_public_path__ + "static/media/necessity_spender.5a1ce87b.svg";